export const environment = {
  production: false,
  env: 'test',
  baseUrl: 'https://api-pahdp.clients-test.aws.alterna-energie.fr/v1',
};
